import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Slider from "@/v2/user-interface/_common/Slider";
import { translate } from "@/v2/user-interface/_common/i18n/i18n";
import { useOutletContext } from "react-router";
import { setShowMyProfile } from "../../authenticated-frame.local-state";
export default function MyProfile() {
    const { localState, localDispatch } = useOutletContext();
    function hideMe() {
        localDispatch(setShowMyProfile({ showMyProfile: false }));
    }
    return (_jsx(Slider, { show: localState.showMyProfile, hideSlider: hideMe, bodyEl: _jsx("h1", { children: "slider body" }), footerEl: _jsxs(_Fragment, { children: [_jsx("button", { type: "button", className: "btn btn-sm btn-outline-secondary", onClick: hideMe, value: "Cancel", children: translate("my-billing-slider.cancel") }), _jsx("button", { className: "btn btn-sm btn-primary", children: translate("my-profile-slider.save") })] }), titleEl: _jsx(_Fragment, { children: translate("my-profile-slider.edit-my-profile") }) }));
}
